// extracted by mini-css-extract-plugin
export default {"segment-title-container":"SegmentTitle_segment-title-container__-JMMK","title":"SegmentTitle_title__y0fF3"};